import { z } from "zod"

export const ListSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  count_customers: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
})

export type List = z.infer<typeof ListSchema>
